import { Listing } from './listing.type';

export const getAmenities = (
    listing: Pick<Listing, 'features'>
): {
    [key: string]: number;
} => {
    const amenityLabelMap = {
        bed: 'bedrooms',
        bath: 'bathrooms',
        chair: 'livingRooms'
    };

    const features: {
        [key: string]: number;
    } = {
        bedrooms: 0,
        bathrooms: 0,
        livingRooms: 0
    };

    listing.features?.forEach((feature) => {
        if (feature?.content && feature?.iconId) {
            features[
                amenityLabelMap[feature.iconId as keyof typeof amenityLabelMap]
            ] = feature.content;
        }
    });

    return features;
};
